import { Heading, Paragraph } from '@zillow/constellation-10';

import clickstreamUtils from '../../../../utils/clickstreamUtils';

import SpecialOffersCSEvents from '../../../../model/ClickstreamEvent/SpecialOffersCSEvents';

import RMWPopover from '../../../RMWPopover';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

interface CurrentPropertyListing extends ZrmClickstreamListing {
  active: boolean;
  dateLastActivatedTimestamp?: string;
  lastActivatedMs?: number;
}

type Props = {
  currentProperty: CurrentPropertyListing;
  user: ZrmClickstreamUser;
  triggerLocation: string;
  dataEventId?: string;
};

const InfoPopover = ({ triggerLocation, currentProperty, user }: Props) => {
  const handleOnOpen = () => {
    const triggerLocationSuffix = clickstreamUtils.getListingStatusSuffix(
      currentProperty?.active,
      currentProperty?.dateLastActivatedTimestamp || String(currentProperty?.lastActivatedMs) || '',
    );
    const triggerLocationWithListingSuffix = `${triggerLocation}${triggerLocationSuffix}`;
    SpecialOffersCSEvents.SpecialOffersLearnMore({
      currentProperty,
      user,
      triggerLocation: triggerLocationWithListingSuffix,
    });
  };

  return (
    <RMWPopover
      handleOnOpen={() => handleOnOpen()}
      header={<Heading level={2}>Special offer</Heading>}
      body={
        <>
          <Paragraph>
            Special offers are deals or discounts you’re offering to prospective renters on your listing.
          </Paragraph>
          <br />
          <Paragraph>Example: Get $500 off first month’s rent when you sign by October 15.</Paragraph>
        </>
      }
      onOpenDataEventId={SpecialOffersCSEvents.SpecialOffersLearnMore.data_event_id}
    />
  );
};

export default InfoPopover;
